import { useState } from "react";

export function useDrillStack<T>(initial: T, onClose: () => void) {
  const [stack, setStack] = useState<T[]>([initial]);

  return {
    stack,
    current: stack.at(-1) ?? initial,
    push: (level: T) => setStack((previous) => [...previous, level]),
    drillTo: (depth: number) => (depth === 0 ? onClose() : setStack((previous) => previous.slice(0, depth))),
  };
}
